import React, { useState } from 'react';
import './Bakeliteinje.css';
import Bakeliteinj1 from '../../../imgs/Bakeliteinj1.webp';
import Bakeliteinj2 from '../../../imgs/Bakeliteinj2.webp';
import Bakeliteinj3 from '../../../imgs/Bakeliteinj3.webp';
import Bakeliteinj4 from '../../../imgs/Bakeliteinj4.webp';
import Reqprodcte from "../../../components/Reqprodcte";

const images = [
    { src: Bakeliteinj1 },
    { src: Bakeliteinj2 },
    { src: Bakeliteinj3 },
    { src: Bakeliteinj4 },
];

const Bakeliteinje = () => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((current + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    const goToSlide = (index) => {
        setCurrent(index);
    };

    return (
        <div className="Plastbucket-main-container">

            <div className="Plastbucket-slideshow">
                {images.map((img, index) => (
                    <div className={index === current ? "mySlides active" : "mySlides"} data-aos="fade-down" key={index}>
                        {index === current && (
                            <>
                                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image" />
                            </>
                        )}
                    </div>
                ))}
                <a className="prev" onClick={prevSlide}>&#10094;</a>
                <a className="next" onClick={nextSlide}>&#10095;</a>

                <div className="dots">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === current ? "dot active" : "dot"}
                            onClick={() => goToSlide(index)}
                        ></span>
                    ))}
                </div>
            </div>

            <div className="Plastbucket-text">
                <h2>Bakelite Injection Molding Machine</h2>
                <h3>T SERIES</h3>
                <p>
                    T Series bakelite injection molding machine are specialized for bakelite products like handle, hand wheel and hand knob etc. Higher productivity and more stable production with improved machine which specialized for making bakelite products. </p>
                <ul>
                    <li><strong>Clamping Force:</strong> – 90/120/128/160/200/250/288(Ton)</li>
                    <li><strong>Shot Weight(PS):</strong> –  1750(g) Max</li>

                    <li><strong>Injection Speed :</strong> -  64(g/s) Max</li>
                </ul>
                <div className='stnd'>
                    <Reqprodcte />
                </div>                </div>
        </div>
    );
};
export default Bakeliteinje;
